import { createRoutine } from 'redux-saga-routines';
import { GET_PERFORMANCES, GET_HOME_NUMBERS, GET_ARTISTS, GET_HIGHLIGHTS } from './constants';

export const getHomePerformancesAction = createRoutine(GET_PERFORMANCES);
export const getHomeNumbersAction = createRoutine(GET_HOME_NUMBERS);
export const getHomeArtistsAction = createRoutine(GET_ARTISTS);
export const getHomeHighlightsAction = createRoutine(GET_HIGHLIGHTS);
